<template>
  <div>
    <el-container>
      <!-- 侧边栏 -->
      <el-aside
        :width="asideWidth"
        style="
          min-height: 100vh;
          background: linear-gradient(to bottom right, #004481, black);
          border-radius: 10px;
          z-index: 9999;
        "
        class="no-print"
      >
        <div
          style="
            height: 60px;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <img
            src="@/assets/xylogo.png"
            alt=""
            style="width: 40px; height: 40px"
          />
          <span class="logo-title" v-show="!isCollapse">
            <el-row :gutter="10">
              <el-col>
                <div style="width: 140px; height: 40px" id="xy"></div>
              </el-col>
            </el-row>
          </span>
        </div>

        <el-menu
          :collapse="isCollapse"
          :collapse-transition="false"
          router
          background-color="#001324"
          text-color="rgba(255,255,255,0.65)"
          active-text-color="#fff"
          style="border: none; box-shadow: 0 0 15px 10px #001324"
          :default-active="$route.path"
        >
          <el-menu-item index="/manager/home">
            <i class="el-icon-s-home" style="margin-left: -5px"></i>
            <span slot="title">系统首页</span>
          </el-menu-item>
          <el-submenu index="/info" v-if="user.data.role === '管理员'">
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span>信息管理</span>
            </template>
            <el-menu-item index="/manager/user">
              <i class="el-icon-user-solid" style="margin-left: -5px"></i>
              <span slot="title">人员信息</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="/manager/shopping">
            <i class="el-icon-shopping-cart-2" style="margin-left: -5px"></i>
            <span slot="title">商品展示</span>
          </el-menu-item>
          <el-submenu index="/product" v-if="user.data.role === '管理员'">
            <template slot="title">
              <i class="el-icon-s-goods"></i>
              <span>商品管理</span>
            </template>
            <el-menu-item index="/manager/product">
              <i class="el-icon-goods" style="margin-left: -5px"></i>
              <span slot="title">商品信息</span>
            </el-menu-item>
            <el-menu-item index="/manager/productType">
              <i class="el-icon-eleme" style="margin-left: -5px"></i>
              <span slot="title">商品分类</span>
            </el-menu-item>
          </el-submenu>

          <el-menu-item
            index="/manager/credit"
            v-if="user.data.role === '管理员'"
          >
            <i class="el-icon-user" style="margin-left: -5px"></i>
            <span slot="title">赊账人员管理</span>
          </el-menu-item>
          <el-menu-item
            index="/manager/notice"
            v-if="user.data.role === '管理员'"
          >
            <i class="el-icon-microphone" style="margin-left: -5px"></i>
            <span slot="title">系统公告</span>
          </el-menu-item>
          <el-menu-item
            index="/manager/orders"
            v-if="user.data.role === '管理员'"
          >
            <i class="el-icon-s-order" style="margin-left: -5px"></i>
            <span slot="title">订单管理</span>
          </el-menu-item>
        </el-menu>
      </el-aside>

      <el-container>
        <!-- 头部区域 -->
        <el-header
          class="no-print"
          style="
            background: linear-gradient(to bottom right, white, #a5cee7);
            margin-left: 10px;
            border-radius: 10px;
            display: flex;
            align-items: center;
          "
        >
          <i
            :class="collapseIcon"
            style="font-size: 26px; margin-top: 15px;margin-left: 10px"
            @click="handleCollapse"
          ></i>
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            style="margin-left: 40px; margin-top: 21px"
          >
            <el-breadcrumb-item>
              <span
                @click="backHome"
                style="cursor: pointer; font-weight: bold; color: black"
                >主页</span
              >
            </el-breadcrumb-item>
            <el-breadcrumb-item>{{ $route.meta.name }}</el-breadcrumb-item>
          </el-breadcrumb>
              <div class="user-info">
            <!-- <i class="el-icon-full-screen" style="font-size:26px;margin-left:-8000px; margin-top:-40px;position:absolute"></i> -->
            <el-dropdown placement="bottom">
              <div style="display: flex; align-items: center; cursor: default">
                <i
                  class="el-icon-full-screen"
                  @click="fullScreen"
                  style="
                    font-size: 25px;
                    color: #00284b;
                    font-weight: bold;
                    margin-right: 10px;
                  "
                ></i>
                <img
                  :src="user1[0].avatar"
                  alt=""
                  style="
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    margin-left: 10px;
                   
                    
                  "
                />
                <span
                  >{{ user1[0].username }}</span
                >
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  @click.native="$router.push('/manager/person')"
                  >个人信息</el-dropdown-item
                >
                <el-dropdown-item
                  @click.native="$router.push('/manager/password')"
                  >修改密码</el-dropdown-item
                >
                <el-dropdown-item @click.native="logout"
                  >退出登录</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        <!-- 主体区域 -->
        <el-main style="background: linear-gradient(to right, white)">
          <transition name="fade-transform" mode="out-in">
            <router-view />
          </transition>

          <transition name="fade-transform" mode="out-in">
            <img
              src="@/assets/kefu.svg"
              style="top: 92%; left: 95%; cursor: pointer; position: fixed"
              @click="toggleChatWindow"
              class="no-print"
            />
          </transition>
          <transition name="fade-transform" mode="out-in">
            <div v-if="showChatWindow" class="chat-window" ref="messageArea">
              <div class="messages">
                <transition-group name="fade" tag="div" class="messages">
                  <div
                    v-for="(message, index) in combinedMessages"
                    :key="index"
                    class="message-container"
                  >
                    <div v-if="message.type === 'user'" class="user-message">
                      <img
                        style="width: 15px; height: 15px; border-radius: 50%"
                        :src="user.data.avatar"
                      />
                      <b>:</b>{{ message.text }}
                    </div>
                    <div
                      v-else-if="message.type === 'customer'"
                      class="customer-message"
                    >
                      <img
                        style="width: 15px; height: 15px; border-radius: 50%"
                        src="@/assets/kefu.svg"
                      />
                      <b>:</b>{{ message.text }}
                    </div>
                  </div>
                </transition-group>
              </div>
            </div>
          </transition>
          <transition name="fade-transform" mode="out-in">
            <div class="input-area" id="oInput">
              <!-- <input  
          type="text"  
          v-model="inputMessage"  
          @keyup.enter="sendMessage"  
          placeholder="输入信息并回车发送"  
        />  
        <button @click="sendMessage">发送</button>   -->
              <el-input
                v-model="inputMessage"
                @keyup.enter="sendMessage"
                placeholder="请输入 "
                style="width: 120px"
                @keyup.enter.native="sendMessage"
              ></el-input>

              <el-button type="primary" @click="sendMessage">发 送</el-button>
            </div>
          </transition>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as echarts from "echarts";
import screenfull from "screenfull";
let user = JSON.parse(localStorage.getItem("honey-user") || "{}");
// import axios from "axios";
import request from "@/utils/request";
const option = {
  graphic: {
    elements: [
      {
        type: "text",
        left: "center",
        top: "center",
        style: {
          text: "心意超市管理系统",
          fontSize: 17 + "px",
          lineDash: [0, 50],
          lineDashOffset: 0,
          fill: "transparent",
          stroke: "white",
          lineWidth: 1,
        },
        keyframeAnimation: {
          duration: 3000,
          loop: true,
          keyframes: [
            {
              percent: 0.7,
              style: {
                fill: "transparent",
                lineDashOffset: 200,
                lineDash: [200, 0],
              },
            },
            {
              // Stop for a while.
              percent: 0.8,
              style: {
                fill: "transparent",
              },
            },
            {
              percent: 1,
              style: {
                fill: "red",
              },
            },
          ],
        },
      },
    ],
  },
};
export default {
  name: "Manager",
  data() {
    return {
      isCollapse: false, //不收缩
      asideWidth: "200px",
      collapseIcon: "el-icon-s-fold",
      users: [],
      user: JSON.parse(localStorage.getItem("honey-user") || "{}"),
      user1: [
        {
          username: "",
          avatar: "",
        },
      ],
      showChatWindow: false,
      combinedMessages: [], // 合并的用户和客服消息列表
      inputMessage: "",
      websocket: null,
      autoSendMessage: "宋楼心意超市，祝您购物开心满意，有什么需要吗？",
    };
  },
created() {
  // 确保 this.$baseUrl 是 http:// 或 https:// 开头
  let baseUrl = this.$baseUrl.replace(/^https?:\/\//, '');
  this.websocket = new WebSocket("ws://" + baseUrl + "/websocket");
  this.websocket.onmessage = this.receiveMessage;

},

  mounted() {
    let xyDom = document.getElementById("xy");
    let xyChart = echarts.init(xyDom);
    xyChart.setOption(option);
    this.getPerson();

    //页面加载完成后触发
    //旧方式
    // axios.get('http://localhost:9090/user/getList').then(res=>{
    //   console.log(res);
    //   this.users=res.data.data
    // })
    request
      .get("/user/getList", {
        params: {
          token: user.data.token,
        },
      })
      .then((res) => {
        this.users = res.data;
      });

    // request.get('/user/getList').then(res=>{
    //   this.users=res.data
    // })
  },
  methods: {
    getPerson() {
      this.$request
        .get("/user/getQuery", {
          params: {
            token: this.user.data.token,
            id: this.user.data.id,
          },
        })
        .then((res) => {
          this.user1 = res.data;
          console.log(this.user1);
        })
        .catch((res) => {
          return this.$message.warning("没有此人员");
        });
    },
    fullScreen() {
      // if (screenfull.isEnabled && !screenfull.isFullscreen) {
      //   screenfull.request();
      // }
      // if(screenfull.isEnabled && screenfull.isFullscreen){
      //   screenfull.exit();
      // }
      screenfull.toggle();
    },

    backHome() {
      if (this.$route.path !== "/manager/home") {
        this.$router.push("/manager/home");
      } else {
        this.$message.warning("您已经在首页了");
      }
    },
    //    toggleChatWindow() {

    //   this.showChatWindow = !this.showChatWindow;
    // },
    toggleChatWindow() {
      this.showChatWindow = !this.showChatWindow;
      // 如果聊天窗口被打开，则发送自动消息
      if (this.showChatWindow) {
        document.getElementById("oInput").style.display = "block";
      } else {
        document.getElementById("oInput").style.display = "none";
      }
      if (this.showChatWindow && this.autoSendMessage) {
        const customerMessage = {
          type: "customer",
          text: this.autoSendMessage,
        };
        this.combinedMessages.push(customerMessage);

        // 发送WebSocket消息
        if (this.websocket.readyState === WebSocket.OPEN) {
          this.websocket.send(this.autoSendMessage);
        }

        // 可选：发送后清空或重置自动发送的消息
        this.autoSendMessage = "";
      }
    },
    receiveMessage(event) {
      const customerMessage = {
        type: "customer",
        text: event.data,
      };
      this.combinedMessages.push(customerMessage);
    },

    sendMessage() {
      if (this.inputMessage) {
        const userMessage = {
          type: "user",
          text: this.inputMessage,
        };
        this.combinedMessages.push(userMessage);
        this.websocket.send(this.inputMessage);
        this.inputMessage = "";
        this.scrollMessageAreaToBottom();
      }
    },
    scrollMessageAreaToBottom() {
      // 将消息框滑动到最底部
      this.$nextTick(() => {
        const messageArea = this.$refs.messageArea;
        if (messageArea) {
          messageArea.scrollTop = messageArea.scrollHeight;
        }
      });
    },
    logout() {
      localStorage.removeItem("honey-user"); //清除当前的token和用户数据
      var youke = {
        code: 200,
        message: "游客",
        data: {
          id: 1,
          username: "游客",
          password: "游客",
          updateTime: null,
          token: "游客",
          role: "游客",
        },
        ok: true,
      };
      // localStorage.setItem("honey-user",JSON.stringify(youke)); //存储用户

      this.$router.push("/");
    },
    handleCollapse() {
      this.isCollapse = !this.isCollapse;
      this.asideWidth = this.isCollapse ? "64px" : "200px";
      this.collapseIcon = this.isCollapse
        ? "el-icon-s-unfold"
        : "el-icon-s-fold";
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.28s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.4s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.chat-window {
  width: 300px;
  height: 400px;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
  /* margin-left: 980px; */
  left: 79%;
  top: 30%;
  background-color: rgba(0, 24, 41, 0.4);
  border-radius: 30px;
  /* margin-top: 130px; */
  border: 1px solid #ccc;
  position: fixed;
  overflow-y: auto;
}

.messages {
  padding: 10px;
}

.message-container {
  margin-bottom: 10px;
  clear: both; /* 确保每个消息容器都从新的一行开始 */
}

.user-message {
  float: right; /* 用户消息显示在右侧 */
  max-width: 70%;
  background-color: #e6f7ff;
  color: blue;
  padding: 5px 10px;
  border-radius: 5px 5px 5px 0;
  margin-top: 10px;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 35);
  clear: right; /* 清除右侧浮动 */
}

.customer-message {
  float: left; /* 客服消息显示在左侧 */
  max-width: 70%;
  background-color: #d4edda;
  color: green;
  padding: 5px 10px;
  border-radius: 5px 5px 0 5px;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 35);

  clear: left; /* 清除左侧浮动 */
  margin-top: 10px;
}

.input-area {
  position: fixed;
  /* margin-top: 535px; */
  padding: 10px;
  background-color: rgba(0, 24, 41, 0.1);
  border-radius: 30px;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 35);

  /* margin-left: 980px; */
  left: 80%;
  top: 91%;
  display: none;
}
.el-menu--inline {
  background-color: #000c17 !important;
}
.el-menu--inline .el-menu-item {
  background-color: #000c17 !important;
  padding-left: 49px !important;
}
/* .el-menu-item,:hover,.el-submenu__title:hover{
  color: #fff !important;
} */
.el-submenu__title:hover i {
  color: #fff !important;
}
.el-submenu__title:hover {
  color: #fff !important;
}
.el-menu-item.is-active {
  background-color: #1890ff !important;
  border-radius: 5px;
  width: calc(100% - 8px);
  margin-left: 4px;
}
.el-menu-item.is-active i,
.el-menu-item.is-active .el-tooltip {
  margin-left: -4px;
}
.el-menu-item {
  height: 40px !important;
  line-height: 40px !important;
  margin: 4px !important;
}
.el-menu-item:hover i {
  color: #fff !important;
}
.el-menu-item:hover {
  color: #fff !important;
}
.el-submenu__title {
  height: 40px !important;
  line-height: 40px !important;
}
.el-submenu .el-menu-item {
  min-width: 0 !important;
}
.el-menu--inline .el-menu-item.is-active {
  padding-left: 45px !important;
}
.el-aside {
  transition: width 0.3s;
  box-shadow: 10px 5px 8px rgba(0, 21, 41, 35);
}
.logo-title {
  margin-left: 5px;
  font-size: 17px;
  transition: all 0.3s;
}
.el-header {
  box-shadow: 2px 4px 6px rgba(0, 21, 41, 35);
  /* position: fixed; */
  width: 100%;
  /* background-color: red; */
}
.el-icon-full-screen:hover {
  color: aqua !important;
}
.user-info {
  display: flex;
  align-items: center;
  margin-left: auto;
}
.user-info img {
  border-radius: 50%;
  margin-right: 10px;
}
.user-info span {
  color: black;
}
@media print {
  .no-print {
    display: none;
  }
}
</style>